import React, { SFC } from "react";
import { PersonalTaxFormTitle } from "../PersonalTaxFormTitle";
import { Trans } from "@lingui/macro";
import { BugerlijkeStaatField } from "./types";
import { PrimaryCheckboxField } from "./PrimaryCheckboxField";
import { AJR, IJR } from "../../../settings";

export interface Props {}

const formPersonal: BugerlijkeStaatField[] = [
  {
    name: "c1001",
    label: <Trans>Ongehuwd en niet wettelijk samenwonend</Trans>,
  },
  {
    name: "c1002",
    label: <Trans>Gehuwd of wettelijk samenwonend</Trans>,
    children: [
      {
        label: <Trans>sinds {IJR} en voordien nog niet wettelijk samenwonend</Trans>,
        name: "c1003",
        children: [
          {
            label: <Trans>De nettobestaansmiddelen van uw partner bedroegen 3.330,00 € of minder</Trans>,
            name: "c1004",
          },
        ],
      },
    ],
  },
  {
    name: "c1010",
    label: (
      <Trans>
        weduwnaar, weduwe of daarmee gelijkgesteld (door het overlijden van uw wettelijk samenwonende partner)
      </Trans>
    ),
    children: [
      {
        name: "c1011",
        label: <Trans>Uw echtgenoot of wettelijk samenwonende partner is overleden in {IJR}</Trans>,
      },
    ],
  },
  {
    name: "c1018",
    label: <Trans>Feitelijk gescheiden</Trans>,
    children: [
      {
        name: "c1019",
        label: <Trans>Uw feitelijke scheiding vond plaats in {IJR}</Trans>,
      },
    ],
  },
];

const formPartner: BugerlijkeStaatField[] = [
  {
    name: "c1020",
    label: (
      <Trans>
        Een gehuwde of wettelijk samenwonende internationale ambtenaar die in {IJR} meer dan bedrag € beroepsinkomen
        heeft verkregen die bij overeenkomst vrijgesteld zijn.
      </Trans>
    ),
  },
  {
    name: "c1021",
    label: (
      <Trans>
        Partner van een gehuwde of wettelijk samenwonende internationale ambtenaar die in {IJR} meer dan bedrag €
        beroepsinkomen heeft verkregen die bij overeenkomst vrijgesteld zijn.
      </Trans>
    ),
  },
  {
    name: "c1022",
    label: <Trans>een belastingplichtige die in {IJR} overleden is</Trans>,
    children: [
      {
        name: "c1023",
        label: <Trans>gehuwd of wettelijk samenwonend</Trans>,
      },
      {
        name: "c1024",
        label: (
          <Trans>
            in {IJR} weduwnaar, weduwe geworden of daarmee gelijkgesteld (door het overlijden van zijn of haar wettelijk
            samenwonende partner)
          </Trans>
        ),
      },
    ],
  },
];

const allPrimaryFieldNames = formPersonal.map((f) => f.name).concat(formPartner.map((f) => f.name));

export const BurgerlijkeStaatForm: SFC<Props> = () => {
  return (
    <div className="main">
      <div id="tab_marital">
        <PersonalTaxFormTitle icon="user">
          <Trans>Burgerlijke staat</Trans>
        </PersonalTaxFormTitle>
        <div className="velden">
          <div className="titel">
            <h2>
              <Trans>U was op 1/1/{AJR}:</Trans>
            </h2>
          </div>
          {formPersonal.map((field) => {
            return <PrimaryCheckboxField key={field.name} field={field} allPrimaryFieldNames={allPrimaryFieldNames} />;
          })}

          <div className="titel">
            <h2>
              <Trans>Deze aangifte betreft:</Trans>
            </h2>
          </div>
          {formPartner.map((field) => {
            return <PrimaryCheckboxField key={field.name} field={field} allPrimaryFieldNames={allPrimaryFieldNames} />;
          })}
        </div>
      </div>
    </div>
  );
};

BurgerlijkeStaatForm.displayName = "BurgerlijkeStaatForm";
